import { Objective } from '@/types/objective';
import { Plan } from '@/types/plan';

export const defaultObjectives: Objective[] = [
  {
    id: 'general-360',
    name: 'Complete Evaluation',
    description: 'Great for Sr. Managers',
    category: 'general',
    addedCost: null,
    status: 'active',
    displayOrder: 1,
    features: [
      'Comprehensive performance evaluation',
      'General leadership assessment',
      'Core competencies analysis',
      'Professional impact measurement'
    ]
  },
  {
    id: 'leadership-edge',
    name: 'Leadership Edge',
    description: 'Focused on assessing and developing leadership potential',
    category: 'leadership',
    addedCost: 100,
    status: 'active',
    displayOrder: 2,
    features: [
      'Deep dive into leadership traits',
      'Emotional intelligence assessment',
      'Executive presence evaluation',
      'Decision-making analysis'
    ]
  },
  {
    id: 'career-accelerator',
    name: 'Career Accelerator',
    description: 'Designed to map out your career trajectory',
    category: 'career',
    addedCost: 150,
    status: 'active',
    displayOrder: 3,
    features: [
      'Career path mapping',
      'Skill gap analysis',
      'Industry alignment check',
      'Growth opportunity identification'
    ]
  },
  {
    id: 'collaboration-genius',
    name: 'Collaboration Genius',
    description: 'Enhances team dynamics and interpersonal effectiveness',
    category: 'collaboration',
    addedCost: 200,
    status: 'active',
    displayOrder: 4,
    features: [
      'Team dynamics assessment',
      'Communication style analysis',
      'Conflict resolution evaluation',
      'Remote collaboration effectiveness'
    ]
  }
];

export const defaultPlans: Plan[] = [
  {
    id: 'basic',
    name: 'Complete Evaluation',
    description: 'Great for Sr. Managers',
    basePrice: 199,
    maxEvaluators: 5,
    status: 'active',
    features: [
      'Complete feedback questionnaire',
      'Up to 5 evaluators',
      'Quantitative insights',
      'Detailed report',
      'Action recommendations'
    ]
  },
  {
    id: 'followup',
    name: 'Complete Evaluation + Follow-up',
    description: 'Great for Directors',
    basePrice: 499,
    maxEvaluators: 10,
    status: 'active',
    features: [
      'Complete feedback questionnaire',
      'Up to 10 evaluators',
      'Quantitative insights',
      'Detailed report',
      'Action recommendations',
      'Follow-up assessment',
      'Progress report'
    ]
  },
  {
    id: 'interview',
    name: 'Complete Evaluation + Interviews',
    description: 'Great for C-Suite',
    basePrice: 1499,
    maxEvaluators: 10,
    status: 'active',
    features: [
      'Complete feedback questionnaire',
      'Up to 10 evaluators',
      'Quantitative insights',
      'Detailed report',
      'Action recommendations',
      'In-depth 1-on-1 interviews',
      'Qualitative insights'
    ]
  }
];